import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import Breadcrums from "../../../common/breadcrumbs";
import {
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import Loader from "../../../common/loader";
import { MOBILE_NUMBER_REGEX } from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";

const GlobalSettings = (props) => {
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  // const [ setContactNumber] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_global_settings"), url: "" },
  ];

  useEffect(() => {
    globalSettingsService
      .Details()
      .then((response) => {
        setShowDefault(response && response.data ? response?.data : []);
        // setContactNumber(response?.data?.contact_no);
        // console.log("🚀 ~ .then ~ response:", response.data);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setDataLoaded(true);
      });
  }, []);



  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          validateOnChange={true}
          enableReinitialize
          initialValues={{
            AdminEmail: showdefault && showdefault.admin_email ? showdefault.admin_email : "",
            Contact: showdefault && showdefault.phone_number ? showdefault.phone_number : "",
            CopyRighttxt: showdefault && showdefault.copy_right_text ? showdefault.copy_right_text : "",
            title: showdefault && showdefault.title ? showdefault.title : "",
            refer_point_per_refer : showdefault && showdefault.refer_point_per_refer ? showdefault.refer_point_per_refer : 0, 
            refer_point_value: showdefault && showdefault.refer_point_value ? showdefault.refer_point_value : 0,
            show_subscription: showdefault && showdefault.show_subscription !== undefined ? showdefault.show_subscription : true,
            is_stripe: showdefault && showdefault.is_stripe !== undefined ? showdefault.is_stripe : true,
            // show_facebook: showdefault && showdefault.show_facebook !== undefined ? showdefault.show_facebook : true,
            // show_google: showdefault && showdefault.show_google !== undefined ? showdefault.show_google : true
          }}
          validate={(values) => {
            let error = {};

            if (!values.AdminEmail.trim()) {
              error.AdminEmail = t("label_email_error");
            } else if (!/^[A-Z0-9](\.?[A-Z0-9_%+'-])*@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.AdminEmail)) {
              error.AdminEmail = "Invalid email format";
            }
            if (!String(values.Contact).trim()) {
              error.Contact = t("label_phone_number_required_error");
            } else if (!MOBILE_NUMBER_REGEX.test(values.Contact)) {
              error.Contact = t("label_contact_invalid_error");
            }
            if (!values.CopyRighttxt || !values.CopyRighttxt.trim()) {
              error.CopyRighttxt = t("copyright_error");
            }

            if (!values.title.trim()) {
              error.title = t("label_title_error");
            } else if (values.title.trim().length > 50) {
              error.title = t("label_title_length_error_50");
            }

            // ✅ Referral Reward Points Validation
            if (values.refer_point_per_refer === "" || values.refer_point_per_refer === null) {
              error.refer_point_per_refer = t("refer_point_required_error");
            } else if (isNaN(values.refer_point_per_refer)) {
              error.refer_point_per_refer = t("refer_point_must_be_number");
            } else if (Number(values.refer_point_per_refer) < 0) {
              error.refer_point_per_refer = t("refer_point_cannot_be_negative");
            }

            // ✅ Point Value Validation
            if (values.refer_point_value === "" || values.refer_point_value === null) {
              error.refer_point_value = t("point_value_required_error");
            } else if (isNaN(values.refer_point_value)) {
              error.refer_point_value = t("point_value_must_be_number");
            } else if (Number(values.refer_point_value) < 0) {
              error.refer_point_value = t("point_value_cannot_be_negative");
            }

            return error;
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            console.log("data error ", values);
            setSubmitted(true);
            let formData = new FormData();
            formData.append("admin_email", values.AdminEmail);
            formData.append("phone_number", values.Contact);
            formData.append("copy_right_text", values.CopyRighttxt);
            formData.append("title", values.title);
            formData.append("refer_point_per_refer", values.refer_point_per_refer);
            formData.append("refer_point_value", values.refer_point_value);
            formData.append("show_subscription", values.show_subscription);
            formData.append("is_stripe", values.is_stripe);
            // formData.append("show_facebook", values.show_facebook);
            // formData.append("show_google", values.show_google);
            globalSettingsService
              .Add(formData)
              .then((response) => {
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    setSubmitted(false);
                  }, 2000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting, setFieldTouched }) => (
            <form onSubmit={handleSubmit}>
              {/* {console.log("error", errors)} */}
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("sidebar_link_global_settings")}</h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="AdminEmail" className="text-left d-flex">
                            {t("role_super_admin")} {t("label_email")}:<span className="requirestar">*</span>
                          </label>
                          <input name="AdminEmail" type="text" id="AdminEmail" onChange={handleChange} onBlur={handleBlur} value={values.AdminEmail} className="form-control" />
                          <span className="text-danger d-flex text-left">{errors.AdminEmail && touched.AdminEmail && errors.AdminEmail}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="Contact" className="text-left d-flex">
                            {t("label_contact_no")}:<span className="requirestar">*</span>
                          </label>
                          <input name="Contact" type="text" id="Contact" onChange={handleChange} onBlur={handleBlur} value={values.Contact} className="form-control" />
                          <span className="text-danger d-flex text-left">{errors.Contact && touched.Contact && errors.Contact}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="CopyRighttxt" className="text-left d-flex">
                            {t("label_copy_right_text")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <input name="CopyRighttxt" type="text" id="CopyRighttxt" onChange={handleChange} onBlur={handleBlur} value={values.CopyRighttxt} className="form-control" />
                          <span className="text-danger d-flex text-left">{errors.CopyRighttxt && touched.CopyRighttxt && errors.CopyRighttxt}</span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("title")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <input name="title" type="text" id="title" onChange={handleChange} onBlur={handleBlur} value={values.title} className="form-control" />
                          <span className="text-danger d-flex text-left">{errors.title && touched.title && errors.title}</span>
                        </div>

                        {/* Referral Reward Points */}
                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="refer_point_per_refer" className="text-left d-flex">
                            {t("Referral Reward Points")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="refer_point_per_refer"
                            type="number"
                            id="refer_point_per_refer"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.refer_point_per_refer}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">{errors.refer_point_per_refer && touched.refer_point_per_refer && errors.refer_point_per_refer}</span>
                        </div>

                        {/* Point Value in INR */}
                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="refer_point_value" className="text-left d-flex">
                            {t("Point Value (per point)")}:<span className="requirestar">*</span>{" "}
                          </label>
                          <input
                            name="refer_point_value"
                            type="number"
                            step="0.01"
                            id="refer_point_value"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.refer_point_value}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">{errors.refer_point_value && touched.refer_point_value && errors.refer_point_value}</span>
                        </div>

                        {/* Show Subscription Toggle */}
                        <div className="col-md-12 form-group">
                          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <label htmlFor="show_subscription" className="mb-0" style={{ cursor: "pointer" }}>
                              Show Subscription on App:
                            </label>
                            <input
                              type="checkbox"
                              id="show_subscription"
                              checked={values.show_subscription}
                              onChange={(e) => setFieldValue("show_subscription", e.target.checked)}
                              style={{ width: "18px", height: "18px", cursor: "pointer", flexShrink: 0 }}
                            />
                          </div>
                        </div>

                        {/* Is Stripe Toggle */}
                        <div className="col-md-12 form-group">
                          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <label htmlFor="is_stripe" className="mb-0" style={{ cursor: "pointer" }}>
                              Make Payment Mode Live:
                            </label>
                            <input
                              type="checkbox"
                              id="is_stripe"
                              checked={values.is_stripe}
                              onChange={(e) => setFieldValue("is_stripe", e.target.checked)}
                              style={{ width: "18px", height: "18px", cursor: "pointer", flexShrink: 0 }}
                            />
                          </div>
                        </div>

                        {/* Show Facebook Toggle */}
                        {/* <div className="col-md-12 form-group">
                          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <label htmlFor="show_facebook" className="mb-0" style={{ cursor: "pointer" }}>
                              Show Facebook:
                            </label>
                            <input
                              type="checkbox"
                              id="show_facebook"
                              checked={values.show_facebook}
                              onChange={(e) => setFieldValue("show_facebook", e.target.checked)}
                              style={{ width: "18px", height: "18px", cursor: "pointer", flexShrink: 0 }}
                            />
                          </div>
                        </div> */}

                        {/* Show Google Toggle */}
                        {/* <div className="col-md-12 form-group">
                          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <label htmlFor="show_google" className="mb-0" style={{ cursor: "pointer" }}>
                              Show Google:
                            </label>
                            <input
                              type="checkbox"
                              id="show_google"
                              checked={values.show_google}
                              onChange={(e) => setFieldValue("show_google", e.target.checked)}
                              style={{ width: "18px", height: "18px", cursor: "pointer", flexShrink: 0 }}
                            />
                          </div>
                        </div> */}

                        {/* {hasPermission("/admin/cms/settings/submit") ? ( */}
                        <div className="col-md-12">
                          <button
                            className="btn ripple btn-main-primary signbtn mr-2"
                            type="submit"
                            disabled={submitted ? true : null}
                            onClick={() => {
                              setSubmitClicked(true);
                            }}
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                        </div>
                        {/* ) : null} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default GlobalSettings;


